import { Config } from "@app/config";
import { BasicLeadFormWithQuestion } from "@component/assets/AbstractLeadForm/Steps/BasicLeadFormWithQuestion";
import type { ReactNode } from "react";

export class LeadForm extends BasicLeadFormWithQuestion {
	protected renderPrivacyStatement(): ReactNode {
		return (
			<div className="text-center pt-2 mt-auto">
				A lenti gomb megnyomásával elismerem, hogy megismertem és hozzájárulok az{" "}
				<a
					href={Config.getBankmonitorUrl("/adatvedelem/")}
					// biome-ignore lint: in-page link
					target="_blank"
				>
					Adatvédelmi szabályzatban
				</a>{" "}
				foglalt adatkezeléshez és elfogadom az Online Lakástakarék Pénztár{" "}
				<a
					href={Config.buildSsrFriendlyUrl(
						"BM_BASE_DOCS_URL",
						"/public/promocio/LTP_emag_promo_20250501_20250531.pdf",
					)}
					download="LTP_emag_promo_20250501_20250531.pdf"
					// biome-ignore lint: in-page link
					target="_blank"
				>
					promóciós szabályzatba
				</a>{" "}
				foglaltakat.
			</div>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
